/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { ARMcontext } from '../context/context';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import {
  Teams,
  Login,
  Admin,
  Exams,
  Config,
  Health,
  Players,
  Armcare,
  Velocity,
  Dashboard,
  Scorecard,
  Workloads,
  HowToVideos,
  Leaderboard,
  CreateAccount,
  PlayerVelocity,
  ForgotPassword,
  PlayerWorkloads,
  PurchaseComplete,
  ResetPassword,
  VerifyAccount
} from '../../pages';
import Auth from '../api/Auth';
import { Toast } from '../../components';
import PlayerPortal from '../../pages/player/playerPortal/PlayerPortal';
import configPlayer from '../../pages/config/configPlayer';

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const orgToken = urlParams.get('orgToken')

export default () => {
  const { user, toast, HandleUser, HandleSignOut } = React.useContext(ARMcontext);
  const AUTH = new Auth();

  useEffect(() => {
    if (orgToken) {
      logFromToken();
    }
  }, [])

  async function logFromToken() {
    HandleSignOut();
    const response = await AUTH.logFromToken({
      access_token: orgToken,
      role: 'org-admin'
    });
   
    if (response.status) {
      if(response.data.data.role === 'player') {
        response.data.role = response.data.data.role
        response.data.secondaryRole = 'org-admin'
      }
      HandleUser(response.data);
    }
  }
 

  return (
    <BrowserRouter>
      {toast.status ? <Toast toast={toast} /> : <></>}
      {user.data?.isFirstLogin && user?.access_token && user.role === 'org-admin' && user.data.role !== "player"   ? (
        <Switch>
          <Route path="/config" component={Config} />
          <Route path="/" component={Config} />
        </Switch>
      ) : user?.access_token ? (
        <Switch>
          <Route path="/verify-account" component={VerifyAccount} />
          {(user.role === 'org-admin' || user.data.isAdmin) && <Route path="/admin" component={Admin} />}
          {user.role === 'player' && (
            <>
              <Route path="/exams" component={Exams} />
              <Route path="/leaderboard" component={Leaderboard} />
              <Route path="/scorecard" component={Scorecard} />
              <Route path="/health" component={Health} />
              <Route path="/workloads" component={PlayerWorkloads} />
              <Route path="/velocity" component={PlayerVelocity} />
              <Route path="/config-player" component={configPlayer} />
              
              <Route path="/player-portal" component={PlayerPortal} />
              <Route path="/how-to-videos" component={HowToVideos} />
              <Redirect to={"/player-portal"} />
            </>
          )}
          <Route path="/how-to-videos" component={HowToVideos} />
          <Route path="/dashboard" component={Dashboard} />
          <Route path="/config" component={Config} />
          <Route path="/players" component={Players} />
          <Route path="/armcare" component={Armcare} />
          <Route path="/velocity" component={Velocity} />
          <Route path="/workloads" component={Workloads} />
          <Route path="/teams" component={Teams} />
          <Route path="/" component={Teams} />
          <Redirect to={"/teams"} />
        </Switch>
      ) : (
        <Switch>
          <Route path="/verify-account" component={VerifyAccount} />
          <Route path="/reset-password" component={ResetPassword} />
          <Route path="/success" component={PurchaseComplete} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route path="/create-account" component={CreateAccount} />
          <Route path="/login" component={Login} />
          <Route path="/" component={Login} />
        </Switch>
      )}
    </BrowserRouter>
  );
};
